/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkStatus } from '../../../enums/ThunkStatus';

import { selectInvitationsData } from './invitations.slice';
import { fetchInvitations } from './invitations.thunk';

/* Invitations table hook */
export function useInvitations(pagingSortingAndFiltering, organizationId) {
  const dispatch = useDispatch();
  const invitationsData = useSelector(selectInvitationsData);
  const { pageNumber, numberOfElementsOnAPage, sortColumn, sortOrder, filter } = pagingSortingAndFiltering;

  const getInvitations = () => {
    // This is not triggering only from below useEffect.
    // When re-setting invitations also triggering and needs organizationId
    if (!organizationId) return;
    dispatch(
      fetchInvitations({
        organizationId,
        pagingSortingAndFiltering,
      }),
    );
  };

  useEffect(() => {
    getInvitations();
  }, [
    organizationId,
    pageNumber,
    numberOfElementsOnAPage,
    sortColumn,
    sortOrder,
    filter,
  ]);

  return {
    ready: invitationsData.status === ThunkStatus.SUCCEEDED,
    isLoading: invitationsData.status === ThunkStatus.LOADING,
    items: invitationsData.rowItems,
    page: invitationsData.page,
    getInvitations,
  };
}
